import Report from '../Report';
import FieldSet from '../FieldSet';
import Parameter from '../Parameter';

export default class SpinnerField extends Parameter {
    // Valeur Min
    public Min: string;
    
    // Valeur Max
    public Max: string;
    
    // Valeur d'incrémentation
    public Increment: string;

    /**
     * Constructeur Spinner
     * @param Name 
     * @param Label 
     * @param Type 
     * @param EmptyText 
     * @param Selected 
     * @param Option 
     * @param Listeners 
     * @param Min Extends
     * @param Max Extends
     * @param Increment Extends
     */
    constructor(Name: string = '', Label: string = '', Type: string = 'Spinner', EmptyText: string = '', Selected: string = '', Option: object = {}, Listeners: Array<{ key: string; value: string }> = [], Min: string = '', Max: string = '', Increment: string = '') {
        super(Name, Label, Type, EmptyText, Selected, Option, Listeners);
        this.Min = Min;
        this.Max = Max;
        this.Increment = Increment;
    }

    //#region Methode Static
    
    // Enregistre la class dans la class Parent
    static {
        Parameter.registerSubclass(SpinnerField); 
    }

    //#endregion
    
    /**
     * Check si l'objet à des valeurs
     * @returns boolean
     */
    override HasValue(): boolean {
        return this.Min != null || this.Max != null || this.Increment != null;
    }
    
    /**
     * Propriété filtrées pour la création d'un objet Spinner
     * @returns Dictionnaires Nom / Valeurs
     */
    override getProperties(): Array<[string, any]>{
        return Object.entries(this).filter(([key]) => 
            this.keysToFilter.includes(key) )
    }

    // Créations des clé pour filtrer les propriété de Spinner
    override keysToFilter: string[] =  ['Label', 'Min', 'Max', 'Increment'];

    override create() : SpinnerField{
        return new SpinnerField(this.Name, this.Label, this.Type, this.EmptyText, this.Selected, this.Option, this.Listeners, this.Min, this.Max, this.Increment)
    }
}